<div class="number-stats" [ngStyle]="cardStyles">
  <div class="card stat-card" [ngStyle]="cardStyle">
    <mat-icon
      *ngIf="hasInfoText && isInfoIconInCorner"
      class="card-info-icon card-info-icon-corner"
      [matTooltip]="infoText"
      matTooltipPosition="above"
      aria-hidden="false"
      [attr.aria-label]="infoText"
    >info_outline</mat-icon>
    <div class="card-body">
      <div class="card-content" [ngClass]="contentClasses">
        <div class="card-title-row">
          <mat-icon *ngIf="hasIcon" class="card-lead-icon" aria-hidden="true">{{ statIcon }}</mat-icon>
          <div class="card-title" [innerHTML]="formattedTitle"></div>
          <mat-icon
            *ngIf="hasInfoText && !isInfoIconInCorner"
            class="card-info-icon"
            [matTooltip]="infoText"
            matTooltipPosition="above"
            aria-hidden="false"
            [attr.aria-label]="infoText"
          >info_outline</mat-icon>
        </div>
        <div class="card-value-or-error">
          <ng-container *ngIf="!hasError">
            <input
              *ngIf="isInputNumberStat; else readonlyStat"
              class="card-value card-value-input"
              type="text"
              [ngModel]="statInputValue"
              (ngModelChange)="onStatInputChange($event)"
              (keyup.enter)="onInputStatEnter()"
            />
            <ng-template #readonlyStat>
              <div class="card-value" [ngClass]="valueLengthClass">{{ stat }}</div>
            </ng-template>
          </ng-container>
          <mat-icon *ngIf="hasError" class="stat-error-icon">error_outline</mat-icon>
        </div>
      </div>

      <!-- Caption + trend line under the value (e.g. "gross, unweighted" on the
           left, "▲ 12.3% vs Q2" on the right). Hidden entirely when neither is
           configured, so existing cards render exactly as before. -->
      <div class="card-footer-row" *ngIf="hasFooter" [ngClass]="alignmentClass">
        <span class="card-sub-text" *ngIf="hasSubText">{{ subText }}</span>
        <span class="card-delta" *ngIf="hasDelta" [ngClass]="deltaClass" [ngStyle]="deltaStyle">
          <span class="card-delta-arrow" *ngIf="deltaArrow" aria-hidden="true">{{ deltaArrow }}</span>{{ deltaText }}
        </span>
      </div>
      <div *ngIf="hasSubtitleText && !hasError" class="card-subtitle-row">
        <span *ngIf="subtitleText" class="card-subtitle">{{ subtitleText }}</span>
        <span *ngIf="subtitleSecondaryText" class="card-subtitle-secondary">{{ subtitleSecondaryText }}</span>
      </div>
    </div>
  </div>
</div>
